const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null
);

export const usesIntervalCandidateAccordion = (regimen: unknown): boolean => {
  if (!isRecord(regimen) || !isRecord(regimen.strategy_descriptor)) return false;
  const presentation = regimen.strategy_descriptor.candidate_presentation;
  return isRecord(presentation) && presentation.type === 'interval_accordion';
};
